(function (){
    'use strict';

    angular
        .module('services')
        .service('PlanService', PlanService);

    PlanService.$inject = ['$http', 'API_BASE'];

    function PlanService ($http, API_BASE) {
        var service = this;

        service.getPlans        = getPlans;


        function getPlans () {
            return $http.get(API_BASE + '/plans/list');
        }


    }
})();